(function(){"use strict";try{if(typeof document<"u"){var e=document.createElement("style");e.appendChild(document.createTextNode("._errorWrapper_916gd_27{word-break:break-word}._copyIcon_916gd_31{cursor:pointer;color:#46597c}._settingsWrapper_1wtqy_27{border:1px solid #d7dfea;border-radius:4px;padding:16px;margin-bottom:16px}")),document.head.appendChild(e)}}catch(r){console.error("vite-plugin-css-injected-by-js",r)}})();
import { useQuery as Mr, useLazyQuery as kr, useMutation as Lr, isApolloError as Wr, gql as Ne } from "@apollo/client";
import { __extends as Fr } from "tslib";
import nr, { useState as M, useEffect as F, createContext as $r, useContext as Ur } from "react";
import { FormField as te, FieldWrapper as Z, Badge as Gr, Icon as ar, FlexBox as G, Text as Se, List as Je, Banner as Br, Button as Ae, Tooltip as Yr, Spinner as or, FieldSwitch as Vr, InputSelectionList as Kr, SelectionList as Hr } from "@dixa/lib-shared-habla";
import { Link as Jr } from "react-router-dom";
import { colors as z } from "@dixa/lib-shared-tokens";
import { useInterval as qr } from "react-use";
var xe = "Invariant Violation", qe = Object.setPrototypeOf, zr = qe === void 0 ? function(r, t) {
  return r.__proto__ = t, r;
} : qe, Zr = (
  /** @class */
  function(r) {
    Fr(t, r);
    function t(n) {
      n === void 0 && (n = xe);
      var i = r.call(this, typeof n == "number" ? xe + ": " + n + " (see https://github.com/apollographql/invariant-packages)" : n) || this;
      return i.framesToPop = 1, i.name = xe, zr(i, t.prototype), i;
    }
    return t;
  }(Error)
);
function Y(r, t) {
  if (!r)
    throw new Zr(t);
}
var ir = ["debug", "log", "warn", "error", "silent"], Qr = ir.indexOf("log");
function fe(r) {
  return function() {
    if (ir.indexOf(r) >= Qr) {
      var t = console[r] || console.log;
      return t.apply(console, arguments);
    }
  };
}
(function(r) {
  r.debug = fe("debug"), r.log = fe("log"), r.warn = fe("warn"), r.error = fe("error");
})(Y || (Y = {}));
var sr = "3.11.4";
function J(r) {
  try {
    return r();
  } catch {
  }
}
const ze = J(function() {
  return globalThis;
}) || J(function() {
  return window;
}) || J(function() {
  return self;
}) || J(function() {
  return global;
}) || // We don't expect the Function constructor ever to be invoked at runtime, as
// long as at least one of globalThis, window, self, or global is defined, so
// we are under no obligation to make it easy for static analysis tools to
// detect syntactic usage of the Function constructor. If you think you can
// improve your static analysis to detect this obfuscation, think again. This
// is an arms race you cannot win, at least not in JavaScript.
J(function() {
  return J.constructor("return this")();
});
var Ze = /* @__PURE__ */ new Map();
function Xr(r) {
  var t = Ze.get(r) || 1;
  return Ze.set(r, t + 1), "".concat(r, ":").concat(t, ":").concat(Math.random().toString(36).slice(2));
}
function et(r, t) {
  var n = Xr("stringifyForDisplay");
  return JSON.stringify(r, function(i, f) {
    return f === void 0 ? n : f;
  }, t).split(JSON.stringify(n)).join("<undefined>");
}
function de(r) {
  return function(t) {
    for (var n = [], i = 1; i < arguments.length; i++)
      n[i - 1] = arguments[i];
    if (typeof t == "number") {
      var f = t;
      t = ur(f), t || (t = lr(f, n), n = []);
    }
    r.apply(void 0, [t].concat(n));
  };
}
Object.assign(function(t, n) {
  for (var i = [], f = 2; f < arguments.length; f++)
    i[f - 2] = arguments[f];
  t || Y(t, ur(n, i) || lr(n, i));
}, {
  debug: de(Y.debug),
  log: de(Y.log),
  warn: de(Y.warn),
  error: de(Y.error)
});
var Qe = Symbol.for("ApolloErrorMessageHandler_" + sr);
function cr(r) {
  if (typeof r == "string")
    return r;
  try {
    return et(r, 2).slice(0, 1e3);
  } catch {
    return "<non-serializable>";
  }
}
function ur(r, t) {
  if (t === void 0 && (t = []), !!r)
    return ze[Qe] && ze[Qe](r, t.map(cr));
}
function lr(r, t) {
  if (t === void 0 && (t = []), !!r)
    return "An error occurred! For more details, see the full error text at https://go.apollo.dev/c/err#".concat(encodeURIComponent(JSON.stringify({
      version: sr,
      message: r,
      args: t.map(cr)
    })));
}
function pe(r) {
  return r.definitions.filter(function(t) {
    return t.kind === "OperationDefinition" && !!t.name;
  }).map(function(t) {
    return t.name.value;
  })[0] || null;
}
const Nt = (r, t) => function(n, i) {
  return Mr(n, {
    ...i,
    context: {
      operationName: pe(n),
      ...i == null ? void 0 : i.context,
      widgetId: r,
      widgetType: t
    }
  });
}, Pt = (r, t) => function(n, i) {
  return kr(n, {
    ...i,
    context: {
      operationName: pe(n),
      ...i == null ? void 0 : i.context,
      widgetId: r,
      widgetType: t
    }
  });
}, jt = (r, t, n) => function(i, f) {
  return n.query({
    query: i,
    variables: f,
    context: {
      operationName: pe(i),
      widgetId: r,
      widgetType: t
    }
  });
}, It = (r, t) => function(n, i) {
  return Lr(n, {
    ...i,
    context: {
      operationName: pe(n),
      ...i == null ? void 0 : i.context,
      widgetId: r,
      widgetType: t
    }
  });
};
var De = { exports: {} }, q = {};
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/
var be, Xe;
function fr() {
  if (Xe)
    return be;
  Xe = 1;
  var r = Object.getOwnPropertySymbols, t = Object.prototype.hasOwnProperty, n = Object.prototype.propertyIsEnumerable;
  function i(p) {
    if (p == null)
      throw new TypeError("Object.assign cannot be called with null or undefined");
    return Object(p);
  }
  function f() {
    try {
      if (!Object.assign)
        return !1;
      var p = new String("abc");
      if (p[5] = "de", Object.getOwnPropertyNames(p)[0] === "5")
        return !1;
      for (var O = {}, E = 0; E < 10; E++)
        O["_" + String.fromCharCode(E)] = E;
      var h = Object.getOwnPropertyNames(O).map(function(l) {
        return O[l];
      });
      if (h.join("") !== "0123456789")
        return !1;
      var m = {};
      return "abcdefghijklmnopqrst".split("").forEach(function(l) {
        m[l] = l;
      }), Object.keys(Object.assign({}, m)).join("") === "abcdefghijklmnopqrst";
    } catch {
      return !1;
    }
  }
  return be = f() ? Object.assign : function(p, O) {
    for (var E, h = i(p), m, l = 1; l < arguments.length; l++) {
      E = Object(arguments[l]);
      for (var y in E)
        t.call(E, y) && (h[y] = E[y]);
      if (r) {
        m = r(E);
        for (var v = 0; v < m.length; v++)
          n.call(E, m[v]) && (h[m[v]] = E[m[v]]);
      }
    }
    return h;
  }, be;
}
/** @license React v17.0.2
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var er;
function rt() {
  if (er)
    return q;
  er = 1, fr();
  var r = nr, t = 60103;
  if (q.Fragment = 60107, typeof Symbol == "function" && Symbol.for) {
    var n = Symbol.for;
    t = n("react.element"), q.Fragment = n("react.fragment");
  }
  var i = r.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, f = Object.prototype.hasOwnProperty, p = { key: !0, ref: !0, __self: !0, __source: !0 };
  function O(E, h, m) {
    var l, y = {}, v = null, w = null;
    m !== void 0 && (v = "" + m), h.key !== void 0 && (v = "" + h.key), h.ref !== void 0 && (w = h.ref);
    for (l in h)
      f.call(h, l) && !p.hasOwnProperty(l) && (y[l] = h[l]);
    if (E && E.defaultProps)
      for (l in h = E.defaultProps, h)
        y[l] === void 0 && (y[l] = h[l]);
    return { $$typeof: t, type: E, key: v, ref: w, props: y, _owner: i.current };
  }
  return q.jsx = O, q.jsxs = O, q;
}
var we = {};
/** @license React v17.0.2
 * react-jsx-runtime.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var rr;
function tt() {
  return rr || (rr = 1, function(r) {
    process.env.NODE_ENV !== "production" && function() {
      var t = nr, n = fr(), i = 60103, f = 60106;
      r.Fragment = 60107;
      var p = 60108, O = 60114, E = 60109, h = 60110, m = 60112, l = 60113, y = 60120, v = 60115, w = 60116, R = 60121, D = 60122, A = 60117, I = 60129, k = 60131;
      if (typeof Symbol == "function" && Symbol.for) {
        var s = Symbol.for;
        i = s("react.element"), f = s("react.portal"), r.Fragment = s("react.fragment"), p = s("react.strict_mode"), O = s("react.profiler"), E = s("react.provider"), h = s("react.context"), m = s("react.forward_ref"), l = s("react.suspense"), y = s("react.suspense_list"), v = s("react.memo"), w = s("react.lazy"), R = s("react.block"), D = s("react.server.block"), A = s("react.fundamental"), s("react.scope"), s("react.opaque.id"), I = s("react.debug_trace_mode"), s("react.offscreen"), k = s("react.legacy_hidden");
      }
      var j = typeof Symbol == "function" && Symbol.iterator, V = "@@iterator";
      function Q(e) {
        if (e === null || typeof e != "object")
          return null;
        var a = j && e[j] || e[V];
        return typeof a == "function" ? a : null;
      }
      var N = t.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
      function S(e) {
        {
          for (var a = arguments.length, o = new Array(a > 1 ? a - 1 : 0), u = 1; u < a; u++)
            o[u - 1] = arguments[u];
          ve("error", e, o);
        }
      }
      function ve(e, a, o) {
        {
          var u = N.ReactDebugCurrentFrame, C = u.getStackAddendum();
          C !== "" && (a += "%s", o = o.concat([C]));
          var _ = o.map(function(g) {
            return "" + g;
          });
          _.unshift("Warning: " + a), Function.prototype.apply.call(console[e], console, _);
        }
      }
      var ne = !1;
      function ge(e) {
        return !!(typeof e == "string" || typeof e == "function" || e === r.Fragment || e === O || e === I || e === p || e === l || e === y || e === k || ne || typeof e == "object" && e !== null && (e.$$typeof === w || e.$$typeof === v || e.$$typeof === E || e.$$typeof === h || e.$$typeof === m || e.$$typeof === A || e.$$typeof === R || e[0] === D));
      }
      function B(e, a, o) {
        var u = a.displayName || a.name || "";
        return e.displayName || (u !== "" ? o + "(" + u + ")" : o);
      }
      function ae(e) {
        return e.displayName || "Context";
      }
      function L(e) {
        if (e == null)
          return null;
        if (typeof e.tag == "number" && S("Received an unexpected object in getComponentName(). This is likely a bug in React. Please file an issue."), typeof e == "function")
          return e.displayName || e.name || null;
        if (typeof e == "string")
          return e;
        switch (e) {
          case r.Fragment:
            return "Fragment";
          case f:
            return "Portal";
          case O:
            return "Profiler";
          case p:
            return "StrictMode";
          case l:
            return "Suspense";
          case y:
            return "SuspenseList";
        }
        if (typeof e == "object")
          switch (e.$$typeof) {
            case h:
              var a = e;
              return ae(a) + ".Consumer";
            case E:
              var o = e;
              return ae(o._context) + ".Provider";
            case m:
              return B(e, e.render, "ForwardRef");
            case v:
              return L(e.type);
            case R:
              return L(e._render);
            case w: {
              var u = e, C = u._payload, _ = u._init;
              try {
                return L(_(C));
              } catch {
                return null;
              }
            }
          }
        return null;
      }
      var x = 0, W, X, ee, oe, ie, Pe, je;
      function Ie() {
      }
      Ie.__reactDisabledLog = !0;
      function vr() {
        {
          if (x === 0) {
            W = console.log, X = console.info, ee = console.warn, oe = console.error, ie = console.group, Pe = console.groupCollapsed, je = console.groupEnd;
            var e = {
              configurable: !0,
              enumerable: !0,
              value: Ie,
              writable: !0
            };
            Object.defineProperties(console, {
              info: e,
              log: e,
              warn: e,
              error: e,
              group: e,
              groupCollapsed: e,
              groupEnd: e
            });
          }
          x++;
        }
      }
      function gr() {
        {
          if (x--, x === 0) {
            var e = {
              configurable: !0,
              enumerable: !0,
              writable: !0
            };
            Object.defineProperties(console, {
              log: n({}, e, {
                value: W
              }),
              info: n({}, e, {
                value: X
              }),
              warn: n({}, e, {
                value: ee
              }),
              error: n({}, e, {
                value: oe
              }),
              group: n({}, e, {
                value: ie
              }),
              groupCollapsed: n({}, e, {
                value: Pe
              }),
              groupEnd: n({}, e, {
                value: je
              })
            });
          }
          x < 0 && S("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
        }
      }
      var he = N.ReactCurrentDispatcher, Ee;
      function se(e, a, o) {
        {
          if (Ee === void 0)
            try {
              throw Error();
            } catch (C) {
              var u = C.stack.trim().match(/\n( *(at )?)/);
              Ee = u && u[1] || "";
            }
          return `
` + Ee + e;
        }
      }
      var me = !1, ce;
      {
        var hr = typeof WeakMap == "function" ? WeakMap : Map;
        ce = new hr();
      }
      function Me(e, a) {
        if (!e || me)
          return "";
        {
          var o = ce.get(e);
          if (o !== void 0)
            return o;
        }
        var u;
        me = !0;
        var C = Error.prepareStackTrace;
        Error.prepareStackTrace = void 0;
        var _;
        _ = he.current, he.current = null, vr();
        try {
          if (a) {
            var g = function() {
              throw Error();
            };
            if (Object.defineProperty(g.prototype, "props", {
              set: function() {
                throw Error();
              }
            }), typeof Reflect == "object" && Reflect.construct) {
              try {
                Reflect.construct(g, []);
              } catch (U) {
                u = U;
              }
              Reflect.construct(e, [], g);
            } else {
              try {
                g.call();
              } catch (U) {
                u = U;
              }
              e.call(g.prototype);
            }
          } else {
            try {
              throw Error();
            } catch (U) {
              u = U;
            }
            e();
          }
        } catch (U) {
          if (U && u && typeof U.stack == "string") {
            for (var d = U.stack.split(`
`), P = u.stack.split(`
`), b = d.length - 1, T = P.length - 1; b >= 1 && T >= 0 && d[b] !== P[T]; )
              T--;
            for (; b >= 1 && T >= 0; b--, T--)
              if (d[b] !== P[T]) {
                if (b !== 1 || T !== 1)
                  do
                    if (b--, T--, T < 0 || d[b] !== P[T]) {
                      var $ = `
` + d[b].replace(" at new ", " at ");
                      return typeof e == "function" && ce.set(e, $), $;
                    }
                  while (b >= 1 && T >= 0);
                break;
              }
          }
        } finally {
          me = !1, he.current = _, gr(), Error.prepareStackTrace = C;
        }
        var H = e ? e.displayName || e.name : "", He = H ? se(H) : "";
        return typeof e == "function" && ce.set(e, He), He;
      }
      function ke(e, a, o) {
        return Me(e, !1);
      }
      function Er(e) {
        var a = e.prototype;
        return !!(a && a.isReactComponent);
      }
      function ue(e, a, o) {
        if (e == null)
          return "";
        if (typeof e == "function")
          return Me(e, Er(e));
        if (typeof e == "string")
          return se(e);
        switch (e) {
          case l:
            return se("Suspense");
          case y:
            return se("SuspenseList");
        }
        if (typeof e == "object")
          switch (e.$$typeof) {
            case m:
              return ke(e.render);
            case v:
              return ue(e.type, a, o);
            case R:
              return ke(e._render);
            case w: {
              var u = e, C = u._payload, _ = u._init;
              try {
                return ue(_(C), a, o);
              } catch {
              }
            }
          }
        return "";
      }
      var Le = {}, We = N.ReactDebugCurrentFrame;
      function le(e) {
        if (e) {
          var a = e._owner, o = ue(e.type, e._source, a ? a.type : null);
          We.setExtraStackFrame(o);
        } else
          We.setExtraStackFrame(null);
      }
      function mr(e, a, o, u, C) {
        {
          var _ = Function.call.bind(Object.prototype.hasOwnProperty);
          for (var g in e)
            if (_(e, g)) {
              var d = void 0;
              try {
                if (typeof e[g] != "function") {
                  var P = Error((u || "React class") + ": " + o + " type `" + g + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof e[g] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                  throw P.name = "Invariant Violation", P;
                }
                d = e[g](a, g, u, o, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
              } catch (b) {
                d = b;
              }
              d && !(d instanceof Error) && (le(C), S("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", u || "React class", o, g, typeof d), le(null)), d instanceof Error && !(d.message in Le) && (Le[d.message] = !0, le(C), S("Failed %s type: %s", o, d.message), le(null));
            }
        }
      }
      var re = N.ReactCurrentOwner, _e = Object.prototype.hasOwnProperty, _r = {
        key: !0,
        ref: !0,
        __self: !0,
        __source: !0
      }, Fe, $e, Ce;
      Ce = {};
      function Cr(e) {
        if (_e.call(e, "ref")) {
          var a = Object.getOwnPropertyDescriptor(e, "ref").get;
          if (a && a.isReactWarning)
            return !1;
        }
        return e.ref !== void 0;
      }
      function Or(e) {
        if (_e.call(e, "key")) {
          var a = Object.getOwnPropertyDescriptor(e, "key").get;
          if (a && a.isReactWarning)
            return !1;
        }
        return e.key !== void 0;
      }
      function yr(e, a) {
        if (typeof e.ref == "string" && re.current && a && re.current.stateNode !== a) {
          var o = L(re.current.type);
          Ce[o] || (S('Component "%s" contains the string ref "%s". Support for string refs will be removed in a future major release. This case cannot be automatically converted to an arrow function. We ask you to manually fix this case by using useRef() or createRef() instead. Learn more about using refs safely here: https://reactjs.org/link/strict-mode-string-ref', L(re.current.type), e.ref), Ce[o] = !0);
        }
      }
      function Rr(e, a) {
        {
          var o = function() {
            Fe || (Fe = !0, S("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", a));
          };
          o.isReactWarning = !0, Object.defineProperty(e, "key", {
            get: o,
            configurable: !0
          });
        }
      }
      function xr(e, a) {
        {
          var o = function() {
            $e || ($e = !0, S("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", a));
          };
          o.isReactWarning = !0, Object.defineProperty(e, "ref", {
            get: o,
            configurable: !0
          });
        }
      }
      var br = function(e, a, o, u, C, _, g) {
        var d = {
          // This tag allows us to uniquely identify this as a React Element
          $$typeof: i,
          // Built-in properties that belong on the element
          type: e,
          key: a,
          ref: o,
          props: g,
          // Record the component responsible for creating this element.
          _owner: _
        };
        return d._store = {}, Object.defineProperty(d._store, "validated", {
          configurable: !1,
          enumerable: !1,
          writable: !0,
          value: !1
        }), Object.defineProperty(d, "_self", {
          configurable: !1,
          enumerable: !1,
          writable: !1,
          value: u
        }), Object.defineProperty(d, "_source", {
          configurable: !1,
          enumerable: !1,
          writable: !1,
          value: C
        }), Object.freeze && (Object.freeze(d.props), Object.freeze(d)), d;
      };
      function wr(e, a, o, u, C) {
        {
          var _, g = {}, d = null, P = null;
          o !== void 0 && (d = "" + o), Or(a) && (d = "" + a.key), Cr(a) && (P = a.ref, yr(a, C));
          for (_ in a)
            _e.call(a, _) && !_r.hasOwnProperty(_) && (g[_] = a[_]);
          if (e && e.defaultProps) {
            var b = e.defaultProps;
            for (_ in b)
              g[_] === void 0 && (g[_] = b[_]);
          }
          if (d || P) {
            var T = typeof e == "function" ? e.displayName || e.name || "Unknown" : e;
            d && Rr(g, T), P && xr(g, T);
          }
          return br(e, d, P, C, u, re.current, g);
        }
      }
      var Oe = N.ReactCurrentOwner, Ue = N.ReactDebugCurrentFrame;
      function K(e) {
        if (e) {
          var a = e._owner, o = ue(e.type, e._source, a ? a.type : null);
          Ue.setExtraStackFrame(o);
        } else
          Ue.setExtraStackFrame(null);
      }
      var ye;
      ye = !1;
      function Re(e) {
        return typeof e == "object" && e !== null && e.$$typeof === i;
      }
      function Ge() {
        {
          if (Oe.current) {
            var e = L(Oe.current.type);
            if (e)
              return `

Check the render method of \`` + e + "`.";
          }
          return "";
        }
      }
      function Tr(e) {
        return "";
      }
      var Be = {};
      function Sr(e) {
        {
          var a = Ge();
          if (!a) {
            var o = typeof e == "string" ? e : e.displayName || e.name;
            o && (a = `

Check the top-level render call using <` + o + ">.");
          }
          return a;
        }
      }
      function Ye(e, a) {
        {
          if (!e._store || e._store.validated || e.key != null)
            return;
          e._store.validated = !0;
          var o = Sr(a);
          if (Be[o])
            return;
          Be[o] = !0;
          var u = "";
          e && e._owner && e._owner !== Oe.current && (u = " It was passed a child from " + L(e._owner.type) + "."), K(e), S('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', o, u), K(null);
        }
      }
      function Ve(e, a) {
        {
          if (typeof e != "object")
            return;
          if (Array.isArray(e))
            for (var o = 0; o < e.length; o++) {
              var u = e[o];
              Re(u) && Ye(u, a);
            }
          else if (Re(e))
            e._store && (e._store.validated = !0);
          else if (e) {
            var C = Q(e);
            if (typeof C == "function" && C !== e.entries)
              for (var _ = C.call(e), g; !(g = _.next()).done; )
                Re(g.value) && Ye(g.value, a);
          }
        }
      }
      function Ar(e) {
        {
          var a = e.type;
          if (a == null || typeof a == "string")
            return;
          var o;
          if (typeof a == "function")
            o = a.propTypes;
          else if (typeof a == "object" && (a.$$typeof === m || // Note: Memo only checks outer props here.
          // Inner props are checked in the reconciler.
          a.$$typeof === v))
            o = a.propTypes;
          else
            return;
          if (o) {
            var u = L(a);
            mr(o, e.props, "prop", u, e);
          } else if (a.PropTypes !== void 0 && !ye) {
            ye = !0;
            var C = L(a);
            S("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", C || "Unknown");
          }
          typeof a.getDefaultProps == "function" && !a.getDefaultProps.isReactClassApproved && S("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
        }
      }
      function Dr(e) {
        {
          for (var a = Object.keys(e.props), o = 0; o < a.length; o++) {
            var u = a[o];
            if (u !== "children" && u !== "key") {
              K(e), S("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", u), K(null);
              break;
            }
          }
          e.ref !== null && (K(e), S("Invalid attribute `ref` supplied to `React.Fragment`."), K(null));
        }
      }
      function Ke(e, a, o, u, C, _) {
        {
          var g = ge(e);
          if (!g) {
            var d = "";
            (e === void 0 || typeof e == "object" && e !== null && Object.keys(e).length === 0) && (d += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
            var P = Tr();
            P ? d += P : d += Ge();
            var b;
            e === null ? b = "null" : Array.isArray(e) ? b = "array" : e !== void 0 && e.$$typeof === i ? (b = "<" + (L(e.type) || "Unknown") + " />", d = " Did you accidentally export a JSX literal instead of a component?") : b = typeof e, S("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", b, d);
          }
          var T = wr(e, a, o, C, _);
          if (T == null)
            return T;
          if (g) {
            var $ = a.children;
            if ($ !== void 0)
              if (u)
                if (Array.isArray($)) {
                  for (var H = 0; H < $.length; H++)
                    Ve($[H], e);
                  Object.freeze && Object.freeze($);
                } else
                  S("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
              else
                Ve($, e);
          }
          return e === r.Fragment ? Dr(T) : Ar(T), T;
        }
      }
      function Nr(e, a, o) {
        return Ke(e, a, o, !0);
      }
      function Pr(e, a, o) {
        return Ke(e, a, o, !1);
      }
      var jr = Pr, Ir = Nr;
      r.jsx = jr, r.jsxs = Ir;
    }();
  }(we)), we;
}
process.env.NODE_ENV === "production" ? De.exports = rt() : De.exports = tt();
var c = De.exports;
const Mt = ({
  getValueByKey: r
}) => {
  var i, f;
  const t = (i = r("dixaApiTokenId")) == null ? void 0 : i.value, n = (f = r("dixaApiTokenName")) == null ? void 0 : f.value;
  return /* @__PURE__ */ c.jsx(te, { children: /* @__PURE__ */ c.jsx(Z, { label: "Dixa API-Token", children: !n || !t ? /* @__PURE__ */ c.jsx(c.Fragment, { children: "Something seems odd with the Api-Token. No name and/or id available." }) : /* @__PURE__ */ c.jsxs(c.Fragment, { children: [
    "A Dixa Token with the name",
    " ",
    /* @__PURE__ */ c.jsx(Gr, { variant: "secondary", size: "small", children: n }),
    " ",
    "was created.",
    " ",
    /* @__PURE__ */ c.jsx(Jr, { to: `/settings/integrations/api-tokens/${t}`, children: "You can visit it on the Api-Token page" }),
    "."
  ] }) }) });
}, nt = ({
  error: r
}) => {
  var t, n;
  return ((n = (t = r.extensions) == null ? void 0 : t.integration) == null ? void 0 : n.code) === "DIXA_HEADER_CHECK_ERROR";
}, kt = ({
  errors: r
}) => r.some((t) => nt({ error: t })), at = ({
  error: r
}) => {
  var t, n;
  return ((n = (t = r.extensions) == null ? void 0 : t.integration) == null ? void 0 : n.code) === "DOWNSTREAM_API_AUTHORIZATION_ERROR";
}, Lt = ({
  errors: r
}) => r.some((t) => at({ error: t })), ot = ({
  error: r
}) => {
  var t, n;
  return ((n = (t = r.extensions) == null ? void 0 : t.integration) == null ? void 0 : n.code) === "DOWNSTREAM_API_PERMISSION_ERROR";
}, Wt = ({
  errors: r
}) => r.some((t) => ot({ error: t })), it = ({
  error: r
}) => {
  var t, n;
  return ((n = (t = r.extensions) == null ? void 0 : t.integration) == null ? void 0 : n.code) === "DOWNSTREAM_API_SERVICE_UNAVAILABLE_ERROR";
}, Ft = ({
  errors: r
}) => r.some((t) => it({ error: t })), st = ({
  error: r
}) => {
  var t, n;
  return ((n = (t = r.extensions) == null ? void 0 : t.integration) == null ? void 0 : n.code) === "DOWNSTREAM_API_NOT_FOUND_ERROR";
}, $t = ({
  errors: r
}) => r.some((t) => st({ error: t })), ct = ({
  error: r
}) => {
  var t, n;
  return ((n = (t = r.extensions) == null ? void 0 : t.integration) == null ? void 0 : n.code) === "DOWNSTREAM_API_CONFLICT_ERROR";
}, Ut = ({
  errors: r
}) => r.some((t) => ct({ error: t })), ut = ({
  error: r
}) => {
  var t, n;
  return ((n = (t = r.extensions) == null ? void 0 : t.integration) == null ? void 0 : n.code) === "DOWNSTREAM_API_BAD_REQUEST_ERROR";
}, Gt = ({
  errors: r
}) => r.some((t) => ut({ error: t })), lt = ({
  error: r
}) => {
  var t, n;
  return ((n = (t = r.extensions) == null ? void 0 : t.integration) == null ? void 0 : n.code) === "DOWNSTREAM_API_FORBIDDEN_ERROR";
}, Bt = ({
  errors: r
}) => r.some((t) => lt({ error: t })), ft = ({
  error: r
}) => {
  var t, n;
  return ((n = (t = r.extensions) == null ? void 0 : t.integration) == null ? void 0 : n.code) === "WIDGET_MISCONFIGURED_ERROR";
}, dt = ({
  errors: r
}) => r.some((t) => ft({ error: t })), pt = (r) => {
  const { delay: t = 2e3 } = r || {}, [n, i] = M(!1);
  return F(() => {
    const p = n ? window.setTimeout(() => i(!1), t) : void 0;
    return () => window.clearTimeout(p);
  }, [t, n]), { isCopied: n, copy: (p) => {
    navigator.clipboard.writeText(p), i(!0);
  } };
}, vt = "_errorWrapper_916gd_27", gt = "_copyIcon_916gd_31", Te = {
  errorWrapper: vt,
  copyIcon: gt
}, ht = ({
  error: r,
  retry: t,
  isMisconfigured: n = !1
}) => {
  var m;
  const f = r && Wr(r) && ((m = r == null ? void 0 : r.graphQLErrors) == null ? void 0 : m.length) > 0, { isCopied: p, copy: O } = pt(), E = /* @__PURE__ */ c.jsx(
    ar,
    {
      color: z.red[500],
      size: 16,
      name: "exclamation-triangle-filled"
    }
  );
  if (n || f && dt({
    errors: r.graphQLErrors
  }))
    return /* @__PURE__ */ c.jsxs(G, { margin: "0 0 100", padding: "200", className: Te.errorWrapper, children: [
      /* @__PURE__ */ c.jsx(G, { margin: "0 300 0 0", alignItems: "center", children: E }),
      /* @__PURE__ */ c.jsx(Se.Paragraph, { color: "secondary", children: "This integration is not properly configured and could not be loaded. Please contact your administrator." })
    ] });
  if (!f)
    return /* @__PURE__ */ c.jsx(G, { margin: "200 0", flexDirection: "column", children: /* @__PURE__ */ c.jsx(
      Je.Item,
      {
        contentLeft: E,
        title: "Something went wrong. Please try again later.",
        variant: "dense"
      }
    ) });
  const h = (r == null ? void 0 : r.graphQLErrors) || [];
  return /* @__PURE__ */ c.jsxs(
    G,
    {
      margin: "200 0 300",
      flexDirection: "column",
      className: Te.errorWrapper,
      children: [
        h.map((l, y) => {
          var k;
          const v = (k = l == null ? void 0 : l.extensions) == null ? void 0 : k.integration, w = (v == null ? void 0 : v.message) || (r == null ? void 0 : r.message) || "No error message available", R = (v == null ? void 0 : v.responseBody) && JSON.parse(v == null ? void 0 : v.responseBody), D = (R == null ? void 0 : R.errorMessages) || [], A = (R == null ? void 0 : R.warningMessages) || [], I = [...D, ...A].join(" ");
          return /* @__PURE__ */ c.jsx(
            Je.Item,
            {
              title: w,
              titleSecondary: I,
              contentLeft: E
            },
            y
          );
        }),
        /* @__PURE__ */ c.jsxs(G, { margin: "200 0 300", flexDirection: "column", gap: "200", children: [
          /* @__PURE__ */ c.jsx(
            Br,
            {
              variant: "info",
              description: /* @__PURE__ */ c.jsx(Se.Paragraph, { variant: "4", children: "Please copy the error details by clicking on the button below and include them in your support request." })
            }
          ),
          /* @__PURE__ */ c.jsxs(G, { flexDirection: "row", gap: "200", justifyContent: "space-between", children: [
            t && /* @__PURE__ */ c.jsx(Ae, { variant: "secondary", icon: "sync", onClick: () => t(), children: "Retry" }),
            /* @__PURE__ */ c.jsx(
              Ae,
              {
                variant: "secondary",
                icon: p ? "done" : "copy",
                onClick: () => O(JSON.stringify(h, null, 2)),
                className: Te.copyIcon,
                children: "Copy error payload"
              }
            )
          ] })
        ] })
      ]
    }
  );
};
function Et() {
  return { track: (t, n) => window._partner.events.emit(t, n) };
}
const mt = (r) => {
  switch (r) {
    case "CONNECTED":
      return {
        icon: "check-circle-filled",
        color: z.green[500],
        tooltip: "Connected"
      };
    case "CONNECTING":
      return {
        icon: "sync",
        color: z.neutral[500],
        tooltip: "Connecting.."
      };
    case "CONNECTION_FAILED":
      return {
        icon: "close-circle-filled",
        color: z.red[500],
        tooltip: "Connection failed"
      };
    case "CONNECTION_TIMEOUT":
      return {
        icon: "exclamation-triangle-filled",
        color: z.red[200],
        tooltip: "Connection timeout"
      };
    case "NOT_CONNECTED":
    default:
      return {
        icon: "exclamation-circle-filled",
        color: z.neutral[500],
        tooltip: "Not connected"
      };
  }
}, Yt = ({
  configuration: r,
  integrationId: t,
  integrationType: n,
  label: i
}) => {
  const [f, p] = M("CONNECTING"), { track: O } = Et(), { icon: E, color: h, tooltip: m } = mt(f), l = 3, y = 15, v = 2e3, [w, R] = M({}), [D, A] = M(0), [I, k] = M(v), [s, j] = M(!1), [V, Q] = M(l), { baseUrl: N } = r, S = `${N}/auth/connect/${n.toLowerCase()}/${t}`, ve = `${N}/auth/status/${n.toLowerCase()}/${t}`, ne = f === "CONNECTING", ge = (x) => Object.keys(x).length === 0, B = () => {
    j(!1), A(0);
  };
  F(() => {
    const x = localStorage.getItem("authData");
    if (x) {
      const W = JSON.parse(x ?? "{}");
      R({
        method: "GET",
        headers: {
          "content-type": "application/json",
          authorization: `Bearer ${W.access_token}`
        }
      });
    }
  }, []), F(() => {
    ge(w) || j(!0);
  }, [w]), qr(
    () => {
      D >= V ? (p("CONNECTION_TIMEOUT"), B()) : (ae(), A(D + 1));
    },
    s ? I : null
  );
  const ae = () => {
    Q(y), fetch(ve, { ...w }).then((x) => x.json()).then(({ data: x }) => {
      const { status: W } = x;
      W === "CONNECTING" && p("CONNECTING"), W === "CONNECTED" && (O("settings:view:oauth:succeeded", {
        widgetId: t,
        widgetType: n
      }), p("CONNECTED"), B()), W === "NOT_CONNECTED" && (p("NOT_CONNECTED"), B());
    }).catch((x) => {
      console.warn(
        `Fetching OAuth status failed for ${n} ${t}`,
        x
      ), p("CONNECTION_FAILED"), B();
    });
  }, L = () => {
    O("settings:view:oauth:started", {
      widgetId: t,
      widgetType: n
    }), fetch(S, { ...w }).then((x) => x.json()).then(({ data: x }) => {
      const { url: W } = x, X = 620, ee = 800, oe = window.innerWidth / 2 - X / 2, ie = window.innerHeight / 2 - ee / 2;
      p("CONNECTING"), j(!0), window.open(
        W,
        "DixaPartnerOAuth",
        `toolbar=no,
						location=no,
						status=no,
						menubar=no,
						scrollbars=yes,
						resizable=yes,
						width=${X},
						height=${ee},
						left=${oe},
						top=${ie}`
      );
    }).catch((x) => {
      console.warn(
        `Fetching OAuth connection failed for ${n} ${t}`,
        x
      ), p("CONNECTION_FAILED"), B();
    });
  };
  return /* @__PURE__ */ c.jsxs(c.Fragment, { children: [
    /* @__PURE__ */ c.jsx(te, { span: 3, children: /* @__PURE__ */ c.jsx(
      Z,
      {
        label: i,
        meta: {
          warning: "All agents interact with the widget using your access permissions."
        },
        style: { marginBottom: 20 },
        children: /* @__PURE__ */ c.jsxs(G, { flexDirection: "row", alignItems: "baseline", gap: "300", children: [
          /* @__PURE__ */ c.jsx(
            Ae,
            {
              icon: "key",
              variant: "secondary",
              onClick: L,
              disabled: ne,
              style: { marginBottom: 8 },
              children: "Start authorization"
            }
          ),
          /* @__PURE__ */ c.jsx(Yr, { content: m, children: ne ? /* @__PURE__ */ c.jsx(or, { "data-testid": "oauth-button-spinner", size: 18 }) : /* @__PURE__ */ c.jsx(
            ar,
            {
              "data-testid": "oauth-button-status-icon",
              name: E,
              color: h
            }
          ) })
        ] })
      }
    ) }),
    /* @__PURE__ */ c.jsx(te, { span: 3 })
  ] });
}, dr = $r(null), Vt = (
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  dr.Provider
);
function pr() {
  const r = Ur(dr);
  if (r === null)
    throw Error(
      "useWidgetContext requires WidgetContext to be used higher up in the component tree, below WidgetContextProvider"
    );
  return r;
}
const _t = "_settingsWrapper_1wtqy_27", Ct = {
  settingsWrapper: _t
}, Ot = Ne`
  query getLists {
    Klaviyo {
      get_lists {
        ... on Klaviyo_get_lists_response {
          ... on Klaviyo_GetListListResponseCollectionCompoundDocument {
            data {
              type
              id
              attributes {
                name
                created
                updated
              }
              links {
                self
              }
            }
            links {
              self
            }
          }
          ... on Klaviyo_ClientError_response {
            errors {
              id
              code
              title
              detail
              source {
                pointer
                parameter
              }
            }
          }
          ... on Klaviyo_ServerError_response {
            errors {
              id
              code
              title
              detail
              source {
                pointer
                parameter
              }
            }
          }
        }
      }
    }
  }
`, tr = [], Kt = ({
  settings: r,
  getValueByKey: t,
  handleChangeSelect: n
}) => {
  var I, k;
  const i = "subscriptionListId", f = r == null ? void 0 : r.find(
    (s) => s.key === i
  ), p = (f == null ? void 0 : f.label) ?? "Activate re-/subscription list selection", O = (I = t(i)) == null ? void 0 : I.value, { useQuery: E } = pr(), [h, m] = M(tr), [l, y] = M(!!O), [v, w] = M(O), {
    data: R,
    error: D,
    loading: A
  } = E(Ot, {
    skip: !l,
    fetchPolicy: "no-cache",
    notifyOnNetworkStatusChange: !0
  });
  return F(() => {
    O && (w(O), y(!0));
  }, [O]), F(() => {
    var j, V;
    const s = (j = R == null ? void 0 : R.Klaviyo) == null ? void 0 : j.get_lists;
    if (l && s && !A && !D) {
      const Q = ((V = s == null ? void 0 : s.data) == null ? void 0 : V.map(
        (N) => {
          var S;
          return {
            value: N == null ? void 0 : N.id,
            label: (S = N == null ? void 0 : N.attributes) == null ? void 0 : S.name
          };
        }
      )) || tr;
      m(Q);
    }
  }, [l, R, A, D]), /* @__PURE__ */ c.jsxs(c.Fragment, { children: [
    /* @__PURE__ */ c.jsx(te, { span: 3, children: /* @__PURE__ */ c.jsxs(
      G,
      {
        gap: "300",
        flexDirection: "column",
        className: Ct.settingsWrapper,
        children: [
          /* @__PURE__ */ c.jsx(Z, { label: p, children: /* @__PURE__ */ c.jsx(
            Vr,
            {
              input: {
                name: `${i}-switch`,
                value: "switchValueFromComponent",
                checked: l,
                onChange: () => {
                  const s = !l;
                  s || n(i, {
                    selectedValues: [
                      {
                        label: "",
                        value: ""
                      }
                    ]
                  }), y(s);
                }
              }
            }
          ) }),
          l && D && !A && /* @__PURE__ */ c.jsx(Z, { children: /* @__PURE__ */ c.jsx(ht, { error: D }) }),
          l && !D && A && /* @__PURE__ */ c.jsx(Z, { children: /* @__PURE__ */ c.jsx(G, { justifyContent: "center", margin: "0 0 300 0", children: /* @__PURE__ */ c.jsx(or, {}) }) }),
          l && !D && !A && h && /* @__PURE__ */ c.jsx(Z, { label: "Available lists to subscribe to", children: /* @__PURE__ */ c.jsx(
            Kr,
            {
              required: !0,
              placeholder: "Select a list",
              onChange: (s) => {
                var j;
                n(i, s), w((j = s == null ? void 0 : s.selectedValues) == null ? void 0 : j[0].value);
              },
              getItemTitleByValue: (s) => {
                if (s)
                  return /* @__PURE__ */ c.jsx(Se.Paragraph, { children: s.label });
              },
              value: v ? [
                {
                  label: (k = (h || []).find(
                    (s) => s.value === v
                  )) == null ? void 0 : k.label,
                  value: v
                }
              ] : [],
              equalityFn: (s, j) => s.value === j.value,
              children: h.map((s) => /* @__PURE__ */ c.jsx(Hr.Item, { value: s, children: s.label }, s.value))
            }
          ) })
        ]
      }
    ) }),
    /* @__PURE__ */ c.jsx(te, { span: 3 })
  ] });
}, yt = Ne`
  query read($conversationId: String!) {
    Storage {
      widgetData(conversation: $conversationId)
    }
  }
`, Rt = Ne`
  mutation store($conversationId: String!, $data: Storage_JSONObject) {
    Storage {
      storeWidgetData(conversation: $conversationId, data: $data) {
        data
      }
    }
  }
`;
function Ht(r) {
  const { useQuery: t, useMutation: n } = pr(), [i, f] = M(), [p, O] = M(), [E, h] = M(!1), {
    loading: m,
    data: l,
    error: y
  } = t(yt, {
    skip: !r,
    variables: {
      conversationId: r == null ? void 0 : r.toString()
    }
  }), [v, { loading: w, error: R }] = n(Rt), D = async (A) => await v({
    variables: {
      conversationId: r == null ? void 0 : r.toString(),
      data: A
    }
  }).then(({ data: I }) => {
    var k, s;
    return f(((s = (k = I == null ? void 0 : I.Storage) == null ? void 0 : k.storeWidgetData) == null ? void 0 : s.data) ?? {});
  });
  return F(() => {
    var A;
    !m && l && f(((A = l == null ? void 0 : l.Storage) == null ? void 0 : A.widgetData) ?? {});
  }, [l, m]), F(() => y && O(y), [y]), F(() => h(m), [m]), F(() => R && O(R), [R]), F(() => h(w), [w]), {
    data: i,
    loading: E,
    store: D,
    error: p
  };
}
function Jt(r, t = !0) {
  try {
    return JSON.parse(JSON.stringify(r));
  } catch {
    return t && console.error(`Could not make a copy of ${JSON.stringify(r)}`), {};
  }
}
const qt = (r) => `${r.charAt(0).toUpperCase()}${r.slice(1).toLowerCase()}`, zt = "DD MMM YYYY @ HH:mm";
function Zt(r) {
  try {
    return new Intl.DisplayNames(["en"], { type: "region" }).of(
      r.toUpperCase()
    ) ?? r;
  } catch {
    return r;
  }
}
const Qt = [
  "AF",
  "AX",
  "AL",
  "DZ",
  "AD",
  "AO",
  "AI",
  "AG",
  "AR",
  "AM",
  "AW",
  "AC",
  "AU",
  "AT",
  "AZ",
  "BS",
  "BH",
  "BD",
  "BB",
  "BY",
  "BE",
  "BZ",
  "BJ",
  "BM",
  "BT",
  "BO",
  "BA",
  "BW",
  "BV",
  "BR",
  "IO",
  "BN",
  "BG",
  "BF",
  "BI",
  "KH",
  "CA",
  "CV",
  "BQ",
  "KY",
  "CF",
  "TD",
  "CL",
  "CN",
  "CX",
  "CC",
  "CO",
  "KM",
  "CG",
  "CD",
  "CK",
  "CR",
  "HR",
  "CU",
  "CW",
  "CY",
  "CZ",
  "CI",
  "DK",
  "DJ",
  "DM",
  "DO",
  "EC",
  "EG",
  "SV",
  "GQ",
  "ER",
  "EE",
  "SZ",
  "ET",
  "FK",
  "FO",
  "FJ",
  "FI",
  "FR",
  "GF",
  "PF",
  "TF",
  "GA",
  "GM",
  "GE",
  "DE",
  "GH",
  "GI",
  "GR",
  "GL",
  "GD",
  "GP",
  "GT",
  "GG",
  "GN",
  "GW",
  "GY",
  "HT",
  "HM",
  "VA",
  "HN",
  "HK",
  "HU",
  "IS",
  "IN",
  "ID",
  "IR",
  "IQ",
  "IE",
  "IM",
  "IL",
  "IT",
  "JM",
  "JP",
  "JE",
  "JO",
  "KZ",
  "KE",
  "KI",
  "KP",
  "XK",
  "KW",
  "KG",
  "LA",
  "LV",
  "LB",
  "LS",
  "LR",
  "LY",
  "LI",
  "LT",
  "LU",
  "MO",
  "MG",
  "MW",
  "MY",
  "MV",
  "ML",
  "MT",
  "MQ",
  "MR",
  "MU",
  "YT",
  "MX",
  "MD",
  "MC",
  "MN",
  "ME",
  "MS",
  "MA",
  "MZ",
  "MM",
  "NA",
  "NR",
  "NP",
  "NL",
  "AN",
  "NC",
  "NZ",
  "NI",
  "NE",
  "NG",
  "NU",
  "NF",
  "MK",
  "NO",
  "OM",
  "PK",
  "PS",
  "PA",
  "PG",
  "PY",
  "PE",
  "PH",
  "PN",
  "PL",
  "PT",
  "QA",
  "CM",
  "RE",
  "RO",
  "RU",
  "RW",
  "BL",
  "SH",
  "KN",
  "LC",
  "MF",
  "PM",
  "WS",
  "SM",
  "ST",
  "SA",
  "SN",
  "RS",
  "SC",
  "SL",
  "SG",
  "SX",
  "SK",
  "SI",
  "SB",
  "SO",
  "ZA",
  "GS",
  "KR",
  "SS",
  "ES",
  "LK",
  "VC",
  "SD",
  "SR",
  "SJ",
  "SE",
  "CH",
  "SY",
  "TW",
  "TJ",
  "TZ",
  "TH",
  "TL",
  "TG",
  "TK",
  "TO",
  "TT",
  "TA",
  "TN",
  "TR",
  "TM",
  "TC",
  "TV",
  "UG",
  "UA",
  "AE",
  "GB",
  "US",
  "UM",
  "UY",
  "UZ",
  "VU",
  "VE",
  "VN",
  "VG",
  "WF",
  "EH",
  "YE",
  "ZM",
  "ZW",
  "ZZ"
], Xt = (r) => {
  if (!(r != null && r.trim()))
    return "Please add a valid subdomain";
  const n = ["https://", "http://"].find(
    (p) => r.startsWith(p)
  ), i = n ? `Please remove the protocol \`${n}\` from the hostname` : "", f = r.endsWith("/") ? "Please remove the trailing `/` from the hostname" : "";
  if (i && f)
    return `Please remove the protocol \`${n}\` and the trailing \`/\` from the hostname`;
  if (i)
    return i;
  if (f)
    return f;
};
export {
  ht as DisplayErrors,
  Mt as DixaApiTokenSettings,
  Kt as KlaviyoSubscribeSetting,
  Yt as OAuthSettings,
  Vt as WidgetContextProvider,
  qt as capitalizeFirstCharacter,
  Qt as countryCodes,
  Jt as deepClone,
  zt as defaultDateFormat,
  mt as getConnectionStatusValues,
  Zt as getCountryNameFromCountryCode,
  Ot as getListsQuery,
  kt as hasDixaHeaderCheckError,
  Lt as hasDownstreamApiAuthorizationError,
  Gt as hasDownstreamApiBadRequestError,
  Ut as hasDownstreamApiConflictError,
  Bt as hasDownstreamApiForbiddenError,
  $t as hasDownstreamApiNotFoundError,
  Wt as hasDownstreamApiPermissionError,
  Ft as hasDownstreamApiServiceUnavailableError,
  dt as hasWidgetMisconfiguredError,
  nt as isDixaHeaderCheckError,
  at as isDownstreamApiAuthorizationError,
  ut as isDownstreamApiBadRequestError,
  ct as isDownstreamApiConflictError,
  lt as isDownstreamApiForbiddenError,
  st as isDownstreamApiNotFoundError,
  ot as isDownstreamApiPermissionError,
  it as isDownstreamApiServiceUnavailableError,
  ft as isWidgetMisconfiguredError,
  jt as makeExecuteQuery,
  Pt as makeUseLazyQuery,
  It as makeUseMutation,
  Nt as makeUseQuery,
  pt as useCopyWithDelay,
  Ht as useData,
  Et as useTracking,
  pr as useWidgetContext,
  Xt as validateApiHostName
};
